export interface IBasketItem {
  //!For remote group orders, the product ID is returned via the Article interface.
  //!For all other items, product_id applies.
  readonly id: number;
  readonly product_id?: number;
  readonly label: string;
  readonly coupon_id?: number | string;
  readonly coupon_code?: number | string;
  readonly imageUrl: string;
  readonly hasImage: boolean;
  readonly valid_date?: number;
  readonly time_set: number;
  readonly scheduled_to_hms: number;
  readonly deposit: number;
  readonly variable_price?: number; // Variable price for the item (e.g. voucher)
  readonly extras: ReadonlyArray<IBasketItemExtra>;
  readonly count: number;
  readonly price: number;
  readonly use_menucourse?: boolean;
  readonly canMenucourse?: boolean; // Allow user change menucourse (IH group order)
  menucourse?: number;
  readonly isWebVoucher?: boolean;
  readonly isBenefit?: boolean;
  readonly benefitCostPoints?: number;
  readonly webVoucher_id: number;
  readonly delivery_type: number;
  readonly show_delivery_type: boolean;
  readonly person_count: number;
  readonly show_person_count: boolean;
  readonly canComment: boolean;
  comment: string;
  showComment?: boolean;
  setcomment?(comment: string): void;
  readonly canIncrement: boolean;
  increment(): void;
  readonly canDecrement: boolean;
  decrement(): void;
  readonly canDiscard: boolean;
  discard(): void;
  removeScheduledItems(): Promise<void>;
}

export interface IMenuCourse {
  readonly name: string;
  readonly id: number;
}

export interface IBasketItemExtra {
  readonly subIndex: number;
  readonly count: number;
  title: string;
  title_de: string;
  title_en: string;
  readonly id: number;
  readonly pos_rez_id: number;
  readonly is_real_product: boolean; // Extra ist ein echter Artikel, sonst ist es nur eine Information
}

export interface IOrderedItem extends IItem {
  readonly comment: string;
  readonly menucourse: number;
  readonly state: OrderedItemState;
}
export interface IItem {
  readonly id: number;
  readonly label: string;
  readonly valid_date?: number;
  readonly deposit?: number;
  readonly variable_price?: number;
  readonly extras?: ReadonlyArray<IItemExtra>;
  readonly count: number;
  readonly price: number;
  comment: string;
  readonly hasComment: boolean;
  readonly use_menucourse: boolean;
  menucourse: number;
}

export interface IItemExtra {
  readonly title: string
  readonly subIndex: number;
  readonly count: number;
}

export enum OrderedItemState {
  None = 0,
  InPreperation = 1,
  ReadyForPickUp = 2,
  PickedUp = 3
}